"use strict"; // Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.isControlExperience = exports.getControlExperienceIdentifier = exports.getControlExperienceBaseUrl = exports.createControlFrame = void 0;

var enums_1 = require("../../enums");

var createControlFrame_1 = __importDefault(require("./createControlFrame"));

exports.createControlFrame = createControlFrame_1["default"];

var isControlExperience = function isControlExperience(experience) {
  return !!experience && experience.experienceType === enums_1.ExperienceType.CONTROL;
};

exports.isControlExperience = isControlExperience;

var getControlExperienceBaseUrl = function getControlExperienceBaseUrl(_experience, urlInfo) {
  var host = urlInfo.host,
      guid = urlInfo.guid;
  var urlString = "".concat(host, "/embed/").concat(guid, "/embedControl");
  return new URL(urlString);
};

exports.getControlExperienceBaseUrl = getControlExperienceBaseUrl;

var getControlExperienceIdentifier = function getControlExperienceIdentifier(experience) {
  if (!isControlExperience(experience)) {
    return;
  }

  var contextId = experience.contextId,
      experienceType = experience.experienceType,
      discriminator = experience.discriminator;
  return [contextId, experienceType, discriminator].filter(Boolean).join('-');
};

exports.getControlExperienceIdentifier = getControlExperienceIdentifier;